export const toUTC = (dateString: string) =>
  dateString.endsWith('Z') ? dateString : dateString + 'Z';

export const toMsTimestamp = (dateString: string): number => new Date(toUTC(dateString)).getTime();

export const formatMeetingDate = (dateString: string, locale?: string): string => {
  const date = new Date(toUTC(dateString));
  return date.toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatMeetingTime = (
  meeting: {
    scheduledStartTime: string;
    scheduledEndTime: string;
  },
  locale?: string,
  minutesLabel = 'min',
): string => {
  const startDate = new Date(toUTC(meeting.scheduledStartTime));
  const endDate = new Date(toUTC(meeting.scheduledEndTime));
  const duration = Math.round((endDate.getTime() - startDate.getTime()) / 60000);
  return `${startDate.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  })} (${duration} ${minutesLabel})`;
};
